exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.blur-high-risk[data-v-4270a78e] {\r\n  -webkit-filter: blur(25px);\r\n          filter: blur(25px)\n}\n.blur-high-risk[data-v-4270a78e]:active {\r\n  -webkit-filter: none;\r\n          filter: none;\n}\r\n\r\n", ""]);

// exports
